import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="currentColor"
    stroke="currentColor"
    {...props}
  >
    <path d="M2.5 4.5C2.5 3.11929 3.61929 2 5 2H13.913C14.5978 2 15.2527 2.28091 15.7246 2.77713L21.5 8.8498V20.5C21.5 21.8807 20.3807 23 19 23H5C3.61929 23 2.5 21.8807 2.5 20.5V4.5Z" />
    <path
      d="M12.0002 14.75V15.9167M8.50016 18.25H15.5002C16.1445 18.25 16.6668 17.7277 16.6668 17.0833V13.5833C16.6668 12.939 16.1445 12.4167 15.5002 12.4167H8.50016C7.85583 12.4167 7.3335 12.939 7.3335 13.5833V17.0833C7.3335 17.7277 7.85583 18.25 8.50016 18.25ZM14.3335 12.4167V10.0833C14.3335 8.79467 13.2888 7.75 12.0002 7.75C10.7115 7.75 9.66683 8.79467 9.66683 10.0833V12.4167H14.3335Z"
      stroke="white"
      strokeLinecap="round"
    />
  </svg>
);
